import { cleanCnpj, formatCnpj } from './format-cnpj';

export function formatCpfCnpj(value: string): string {
  const clean = cleanCnpj(value);
  // Até 11 caracteres tratamos como CPF (numérico); acima, CNPJ alfanumérico.
  if (clean.length <= 11) {
    return clean
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return formatCnpj(clean);
}
